<header class="k-d-flex k-px-15 k-py-6.5 k-gap-4 k-flex-wrap k-justify-content-between k-align-items-center"
  style="padding-top: 6.5px; padding-bottom: 6.5px; padding-right: 5px;">
  <div class="k-d-flex-row k-shrink-0 k-flex-basis-0 k-flex-grow k-gap-2 k-align-items-center"
    style="padding-left: 10px;">
    <div class="k-d-flex k-d-flex-col k-flex-nowrap k-gap-3 k-align-items-start" style="padding-left: 5px;">
      <span class="k-font-size-xl !k-m-0 k-font-bold k-white-space-nowrap k-h-6 k-align-middle"
        *ngIf="(user$ | async) as user">
        {{'hi' | translate}}, {{ userDisplayName }}
      </span>
      <span class="k-font-size-md !k-m-0 k-font-medium k-white-space-nowrap">
        {{'welcome_back' | translate}}
      </span>
    </div>
  </div>
  <div class="k-flex-basis-0 k-shrink-0 k-flex-grow">
    <div class="k-d-flex">
      <kendo-autocomplete #cities class="!k-bg-dark k-color-subtle k-border-transparent" [style.minWidth.px]="215"
        [style.maxWidth.px]="360" size="small" [placeholder]="'Search'" rounded="large" fillMode="outline">
        <ng-template kendoPrefixTemplate [showSeparator]="true">
          <kendo-svgicon [icon]="searchIcon"></kendo-svgicon>
        </ng-template>
      </kendo-autocomplete>
    </div>
  </div>
  <div
    class="k-d-flex k-flex-basis-0 k-shrink-0 k-flex-grow k-justify-content-end k-justify-content-sm-start k-gap-3 k-align-items-center">
    <!-- Theme Mode Dropdown -->
    <div class="theme-dropdown-container" (clickOutside)="closeThemeDropdown()">
      <button class="header-icon-button theme" type="button" (click)="toggleThemeDropdown()" [title]="currentThemeTooltip"
        [attr.aria-expanded]="showThemeDropdown" aria-haspopup="true">
        <fa-icon [icon]="currentThemeIcon" class="theme-icon"></fa-icon>
      </button>

      <div class="theme-dropdown-menu" [class.show]="showThemeDropdown" *ngIf="showThemeDropdown">
        <div class="theme-dropdown-label">Theme</div>
        <div class="theme-dropdown-options">
          <button *ngFor="let t of themeModes"
            class="theme-dropdown-option"
            [class.active]="themeSwitcher.themeModeSetting === t.mode"
            (click)="selectThemeMode(t.mode)"
            [title]="t.label">
            <fa-icon [icon]="t.icon" class="theme-option-icon"></fa-icon>
            <span class="theme-option-label">{{ t.label }}</span>
            <span *ngIf="themeSwitcher.themeModeSetting === t.mode" class="theme-option-check">✓</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Profile Dropdown -->
    <div *ngIf="isAuthenticated" class="profile-dropdown-container" (clickOutside)="closeProfileDropdown()">
      <button class="header-icon-button profile-button" type="button" (click)="toggleProfileDropdown()"
        [attr.aria-expanded]="showProfileDropdown" aria-haspopup="true">
        <div class="profile-avatar-wrapper">
          <div class="profile-avatar">
            {{ getUserInitials() }}
          </div>
          <app-connection-status class="avatar-status-badge"></app-connection-status>
        </div>
      </button>

      <!-- Dropdown Menu -->
      <div class="profile-dropdown-menu" [class.show]="showProfileDropdown" *ngIf="showProfileDropdown">
        <!-- Profile Header -->
        <div class="profile-dropdown-header">
          <div class="profile-avatar-large">
            {{ getUserInitials() }}
          </div>
          <div class="profile-info">
            <div class="profile-name">{{ userDisplayName }}</div>
            <div class="profile-email">{{ userEmail }}</div>
          </div>
        </div>

        <div class="profile-dropdown-divider"></div>

        <!-- Menu Items -->
        <div class="profile-dropdown-items">
          <button class="profile-dropdown-item" (click)="navigateToSettings()">
            <kendo-svgicon [icon]="userSvg" class="profile-menu-icon"></kendo-svgicon>
            <span>Account Settings</span>
          </button>

          <div class="profile-dropdown-divider"></div>

          <!-- Language Selector -->
          <div class="profile-language-section">
            <div class="profile-language-label">Language</div>
            <div class="profile-language-options">
              <button *ngFor="let lang of translations"
                class="profile-language-option"
                [class.active]="selectedLanguage.localeId === lang.localeId"
                (click)="changeLanguage(lang)"
                [title]="lang.locale">
                <img [src]="languageFlags[lang.localeId]" [alt]="lang.locale" class="profile-language-flag" />
                <span class="profile-language-name">{{ lang.locale }}</span>
                <span *ngIf="selectedLanguage.localeId === lang.localeId" class="profile-language-check">✓</span>
              </button>
            </div>
          </div>

          <div class="profile-dropdown-divider"></div>

          <button class="profile-dropdown-item logout-item" (click)="logout()">
            <span>Sign Out</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</header>